export const SUPPORT_URL =
  process.env.REACT_APP_SUPPORT_URL ||
  'https://ko-fi.com/learnmicrobes';
